// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__BdDtF","label":"Section_label__Boda5","contentWrap":"Section_contentWrap__2aobm","footer":"Section_footer__3SCdw","footerInner":"Section_footerInner__2DMGL"};